export const averagesWithPlusTests = {
"Biology": {
    "totalQuestions": 600,
    "avgTime": 14356.553198250998,
    "avgScore": 413.76547008522823,
    "count": 15,
    "systems": {
        "Cell Division": {
            "totalQuestions": 23,
            "avgTime": 624.3348606464602,
            "avgScore": 15.853165611948336,
            "count": 13
        },
        "Molecular Genetics": {
            "totalQuestions": 45,
            "avgTime": 1119.116247441579,
            "avgScore": 30.31551035389709,
            "count": 15
        },
        "Endocrine System": {
            "totalQuestions": 26,
            "avgTime": 595.0672303277837,
            "avgScore": 18.18272767448871,
            "count": 14
        },
        "Ecology": {
            "totalQuestions": 28,
            "avgTime": 634.209426237747,
            "avgScore": 20.555809404953127,
            "count": 14
        },
        "Cellular Energy": {
            "totalQuestions": 28,
            "avgTime": 667.0094979810862,
            "avgScore": 20.31250094478297,
            "count": 14
        },
        "Reproduction and Developmental Biology": {
            "totalQuestions": 52,
            "avgTime": 1160.2866904072703,
            "avgScore": 33.85203532918085,
            "count": 15
        },
        "Digestive System": {
            "totalQuestions": 19,
            "avgTime": 373.3435016497563,
            "avgScore": 12.501711181643877,
            "count": 14
        },
        "Heredity": {
            "totalQuestions": 43,
            "avgTime": 1845.424151601949,
            "avgScore": 29.799978262435815,
            "count": 15
        },
        "Cells and Organelles": {
            "totalQuestions": 40,
            "avgTime": 992.5794869900271,
            "avgScore": 29.331554848813454,
            "count": 15
        },
        "Diversity of Life": {
            "totalQuestions": 46,
            "avgTime": 993.9796737228938,
            "avgScore": 30.594673026156507,
            "count": 15
        },
        "Animal Behavior": {
            "totalQuestions": 12,
            "avgTime": 269.54502608319825,
            "avgScore": 9.080122298488137,
            "count": 11
        },
        "Molecules and Fundamentals of Biology": {
            "totalQuestions": 22,
            "avgTime": 492.6921070033879,
            "avgScore": 15.632136738246627,
            "count": 12
        },
        "Circulatory System": {
            "totalQuestions": 25,
            "avgTime": 526.9444363693465,
            "avgScore": 18.657639499102388,
            "count": 13
        },
        "Microscopy and Lab Techniques": {
            "totalQuestions": 19,
            "avgTime": 317.6672078512191,
            "avgScore": 13.463335504936461,
            "count": 13
        },
        "Photosynthesis": {
            "totalQuestions": 16,
            "avgTime": 382.6299122921755,
            "avgScore": 10.511797199828196,
            "count": 13
        },
        "Human Immune System": {
            "totalQuestions": 22,
            "avgTime": 441.4225422253181,
            "avgScore": 13.63610681074765,
            "count": 13
        },
        "Muscular System": {
            "totalQuestions": 17,
            "avgTime": 298.1567526123941,
            "avgScore": 10.354413542381845,
            "count": 13
        },
        "Evolution": {
            "totalQuestions": 35,
            "avgTime": 874.2457617610362,
            "avgScore": 26.138134621011744,
            "count": 15
        },
        "Nervous System": {
            "totalQuestions": 18,
            "avgTime": 402.54502719322704,
            "avgScore": 11.373270132111706,
            "count": 14
        },
        "Excretory System": {
            "totalQuestions": 13,
            "avgTime": 344.648082764332,
            "avgScore": 8.182768982759772,
            "count": 12
        },
        "Plants": {
            "totalQuestions": 25,
            "avgTime": 494.78093694146855,
            "avgScore": 16.359463813781773,
            "count": 14
        },
        "Skeletal System": {
            "totalQuestions": 10,
            "avgTime": 226.48215716221097,
            "avgScore": 7.43562733357801,
            "count": 7
        },
        "Respiratory System": {
            "totalQuestions": 8,
            "avgTime": 181.01082696343488,
            "avgScore": 5.9043180028003865,
            "count": 7
        },
        "Integumentary System": {
            "totalQuestions": 8,
            "avgTime": 98.43165402169421,
            "avgScore": 5.736668967152824,
            "count": 8
        }
    }
},
"General Chemistry": {
    "totalQuestions": 450,
    "avgTime": 22827.614785951722,
    "avgScore": 308.3431791622658,
    "count": 15,
    "systems": {
        "Periodic Trends": {
            "totalQuestions": 40,
            "avgTime": 1530.8873844449436,
            "avgScore": 29.353867987330787,
            "count": 14
        },
        "Liquids and Solids": {
            "totalQuestions": 35,
            "avgTime": 1269.8272833867807,
            "avgScore": 23.761773680192604,
            "count": 13
        },
        "Chemical Kinetics": {
            "totalQuestions": 24,
            "avgTime": 1172.1995560198636,
            "avgScore": 16.106384551722016,
            "count": 12
        },
        "Chemical Equilibria": {
            "totalQuestions": 23,
            "avgTime": 1157.5972047768278,
            "avgScore": 15.26020277704361,
            "count": 13
        },
        "Thermodynamics and Thermochemistry": {
            "totalQuestions": 38,
            "avgTime": 2059.651230882279,
            "avgScore": 25.628260042404747,
            "count": 14
        },
        "Stoichiometry": {
            "totalQuestions": 31,
            "avgTime": 2785.109231641691,
            "avgScore": 22.59689751304102,
            "count": 14
        },
        "Gases": {
            "totalQuestions": 35,
            "avgTime": 2259.81604087772,
            "avgScore": 24.460148101747208,
            "count": 15
        },
        "Chemical Solutions": {
            "totalQuestions": 36,
            "avgTime": 2455.7358332038884,
            "avgScore": 22.515515014667596,
            "count": 15
        },
        "Molecular Structure and Geometry": {
            "totalQuestions": 31,
            "avgTime": 1416.8265565109705,
            "avgScore": 22.732622883902305,
            "count": 15
        },
        "Electrochemistry and Oxidation Reduction Reactions": {
            "totalQuestions": 32,
            "avgTime": 1560.175189297649,
            "avgScore": 20.664594675826898,
            "count": 15
        },
        "Atomic and Electronic Structure": {
            "totalQuestions": 33,
            "avgTime": 1274.8287995654134,
            "avgScore": 24.48185471313932,
            "count": 14
        },
        "Acid Base Equilibria and Titrations": {
            "totalQuestions": 47,
            "avgTime": 2223.8244525576206,
            "avgScore": 29.173641642500584,
            "count": 15
        },
        "Nuclear Reactions": {
            "totalQuestions": 21,
            "avgTime": 992.4656903765112,
            "avgScore": 14.32560934062147,
            "count": 14
        },
        "Laboratory Techniques": {
            "totalQuestions": 24,
            "avgTime": 668.670332409562,
            "avgScore": 17.281806238125625,
            "count": 12
        }
    }
},
"Organic Chemistry": {
    "totalQuestions": 450,
    "avgTime": 19824.002275656778,
    "avgScore": 280.4092536204623,
    "count": 15,
    "systems": {
        "Acids and Bases": {
            "totalQuestions": 43,
            "avgTime": 1800.8063215068587,
            "avgScore": 26.089528868352364,
            "count": 15
        },
        "Nomenclature": {
            "totalQuestions": 40,
            "avgTime": 1936.0564183870054,
            "avgScore": 28.631839257118283,
            "count": 15
        },
        "Stereochemistry": {
            "totalQuestions": 34,
            "avgTime": 1701.71157297215,
            "avgScore": 21.222961826940836,
            "count": 14
        },
        "IM Forces and Lab Techniques": {
            "totalQuestions": 31,
            "avgTime": 1043.4807870277957,
            "avgScore": 21.096404146268785,
            "count": 15
        },
        "Carboxylic Acids and Acid Derivatives": {
            "totalQuestions": 21,
            "avgTime": 865.5415965386729,
            "avgScore": 13.00406339190429,
            "count": 12
        },
        "Spectroscopy": {
            "totalQuestions": 35,
            "avgTime": 1374.3541934739465,
            "avgScore": 22.12438295351383,
            "count": 15
        },
        "Aromatic Compounds": {
            "totalQuestions": 40,
            "avgTime": 2011.9793793780564,
            "avgScore": 23.260272749400766,
            "count": 15
        },
        "Aldehydes and Ketones": {
            "totalQuestions": 36,
            "avgTime": 1655.126152856429,
            "avgScore": 19.85191115291923,
            "count": 15
        },
        "Alkenes and Alkynes": {
            "totalQuestions": 44,
            "avgTime": 1957.6273011171256,
            "avgScore": 28.764366768826786,
            "count": 15
        },
        "Free Radical Halogenation and Diels Alder": {
            "totalQuestions": 12,
            "avgTime": 448.9142627439153,
            "avgScore": 8.077404038686414,
            "count": 8
        },
        "Alpha Substitution Reactions of Carbonyls": {
            "totalQuestions": 10,
            "avgTime": 492.37162741457917,
            "avgScore": 5.508835771836471,
            "count": 8
        },
        "Substitution and Elimination": {
            "totalQuestions": 50,
            "avgTime": 2172.3142400844067,
            "avgScore": 29.221808368898394,
            "count": 15
        },
        "Bonding and Molecular Geometry": {
            "totalQuestions": 34,
            "avgTime": 1528.2521859922135,
            "avgScore": 21.3156620151098,
            "count": 15
        },
        "Alcohols Ethers Epoxides": {
            "totalQuestions": 20,
            "avgTime": 835.4662361636214,
            "avgScore": 12.239812310686066,
            "count": 11
        }
    }
},
"Perceptual Ability": {
    "totalQuestions": 1350,
    "avgTime": 51057.91975817553,
    "avgScore": 914.0356389227052,
    "count": 15,
    "systems": {
        "Keyhole": {
            "totalQuestions": 225,
            "avgTime": 10602.313372005505,
            "avgScore": 139.27982196965738,
            "count": 15
        },
        "TFE": {
            "totalQuestions": 225,
            "avgTime": 8838.879868172444,
            "avgScore": 137.56520941414678,
            "count": 15
        },
        "Angle Ranking": {
            "totalQuestions": 225,
            "avgTime": 6693.8059576918195,
            "avgScore": 135.77289384393038,
            "count": 15
        },
        "Hole Punching": {
            "totalQuestions": 225,
            "avgTime": 9730.101529603575,
            "avgScore": 172.68588128576008,
            "count": 15
        },
        "Cube Counting": {
            "totalQuestions": 225,
            "avgTime": 6447.847968224201,
            "avgScore": 180.0169566557918,
            "count": 15
        },
        "Pattern Folding": {
            "totalQuestions": 225,
            "avgTime": 8744.971062477978,
            "avgScore": 148.7148757534188,
            "count": 15
        }
    }
},
"Reading Comprehension": {
    "totalQuestions": 750,
    "avgTime": 46978.1982548112,
    "avgScore": 541.657253378262,
    "count": 15,
    "systems": {
        "Passage 1": {
            "totalQuestions": 250,
            "avgTime": 16888.842792256426,
            "avgScore": 184.60314918638016,
            "count": 15
        },
        "Passage 2": {
            "totalQuestions": 253,
            "avgTime": 16709.146002028865,
            "avgScore": 187.18005913951936,
            "count": 15
        },
        "Passage 3": {
            "totalQuestions": 247,
            "avgTime": 13380.209460525903,
            "avgScore": 169.87404505236248,
            "count": 15
        }
    }
},
"Quantitative Reasoning": {
    "totalQuestions": 600,
    "avgTime": 35164.06203036919,
    "avgScore": 374.3440771737183,
    "count": 15,
    "systems": {
        "Algebra - Quadratic Equations and Graphical Analysis": {
            "totalQuestions": 55,
            "avgTime": 2980.9002535213554,
            "avgScore": 34.80649485578347,
            "count": 15
        },
        "Statistics, Data Analysis, & Interpretation": {
            "totalQuestions": 59,
            "avgTime": 3116.3015124976146,
            "avgScore": 42.07324592427674,
            "count": 15
        },
        "Word Problems": {
            "totalQuestions": 140,
            "avgTime": 10320.552592556043,
            "avgScore": 84.46131803250093,
            "count": 15
        },
        "Quantitative Comparison": {
            "totalQuestions": 91,
            "avgTime": 3829.97636179342,
            "avgScore": 57.007033151954836,
            "count": 15
        },
        "Algebra - Equations and Inequalities": {
            "totalQuestions": 34,
            "avgTime": 2177.5448555959733,
            "avgScore": 23.631398857779075,
            "count": 14
        },
        "Algebra - Fundamentals ": {
            "totalQuestions": 71,
            "avgTime": 4475.071791961065,
            "avgScore": 48.70928393953944,
            "count": 15
        },
        "Probability": {
            "totalQuestions": 91,
            "avgTime": 5917.9478506994965,
            "avgScore": 55.62671924147331,
            "count": 15
        },
        "Data Sufficiency": {
            "totalQuestions": 54,
            "avgTime": 2134.9172926510073,
            "avgScore": 25.274184931461885,
            "count": 15
        },
        "Geometry": {
            "totalQuestions": 2,
            "avgTime": 94.60985369490261,
            "avgScore": 0.5946974668591679,
            "count": 2
        },
        "Algebra": {
            "totalQuestions": 2,
            "avgTime": 97.81673455859863,
            "avgScore": 1.3437821185130452,
            "count": 2
        },
        "Applied Mathematics": {
            "totalQuestions": 1,
            "avgTime": 18.422930839713867,
            "avgScore": 0.8159186535764376,
            "count": 1
        }
    }
}
};

export const averages = {
    "Biology": {
        "totalQuestions": 400,
        "avgTime": 10107.751653786047,
        "avgScore": 269.3919529816258,
        "count": 10,
        "systems": {
            "Cell Division": {
                "totalQuestions": 15,
                "avgTime": 425.70809429590827,
                "avgScore": 9.908560556301612,
                "count": 9
            },
            "Molecular Genetics": {
                "totalQuestions": 32,
                "avgTime": 937.1754890109055,
                "avgScore": 20.110347943301043,
                "count": 10
            },
            "Endocrine System": {
                "totalQuestions": 17,
                "avgTime": 385.771234664342,
                "avgScore": 11.001199442286667,
                "count": 9
            },
            "Ecology": {
                "totalQuestions": 19,
                "avgTime": 452.98174104632153,
                "avgScore": 14.02788936166504,
                "count": 10
            },
            "Cellular Energy": {
                "totalQuestions": 20,
                "avgTime": 419.9125004891567,
                "avgScore": 15.310989557242241,
                "count": 10
            },
            "Reproduction and Developmental Biology": {
                "totalQuestions": 35,
                "avgTime": 765.4073592691235,
                "avgScore": 22.17469520037341,
                "count": 10
            },
            "Digestive System": {
                "totalQuestions": 13,
                "avgTime": 239.07236959999895,
                "avgScore": 8.206824972492313,
                "count": 9
            },
            "Heredity": {
                "totalQuestions": 30,
                "avgTime": 1382.6859690084939,
                "avgScore": 20.433140816173683,
                "count": 10
            },
            "Cells and Organelles": {
                "totalQuestions": 28,
                "avgTime": 741.2323365257993,
                "avgScore": 20.817903890623974,
                "count": 10
            },
            "Diversity of Life": {
                "totalQuestions": 26,
                "avgTime": 616.7654883775087,
                "avgScore": 16.959349456987923,
                "count": 10
            },
            "Animal Behavior": {
                "totalQuestions": 7,
                "avgTime": 153.33350405108473,
                "avgScore": 5.173272185023471,
                "count": 7
            },
            "Molecules and Fundamentals of Biology": {
                "totalQuestions": 14,
                "avgTime": 301.79900412342835,
                "avgScore": 9.710584402574861,
                "count": 8
            },
            "Circulatory System": {
                "totalQuestions": 16,
                "avgTime": 372.61715081872626,
                "avgScore": 11.437482269252921,
                "count": 8
            },
            "Microscopy and Lab Techniques": {
                "totalQuestions": 12,
                "avgTime": 258.0671122481065,
                "avgScore": 7.694604498085074,
                "count": 9
            },
            "Photosynthesis": {
                "totalQuestions": 8,
                "avgTime": 211.3063683753479,
                "avgScore": 4.898940256778025,
                "count": 8
            },
            "Human Immune System": {
                "totalQuestions": 16,
                "avgTime": 323.17379867125123,
                "avgScore": 9.907369546399618,
                "count": 9
            },
            "Muscular System": {
                "totalQuestions": 10,
                "avgTime": 194.04905800623973,
                "avgScore": 5.820632226066564,
                "count": 8
            },
            "Evolution": {
                "totalQuestions": 25,
                "avgTime": 668.8786328568447,
                "avgScore": 17.794498849715133,
                "count": 10
            },
            "Nervous System": {
                "totalQuestions": 11,
                "avgTime": 247.8827113666307,
                "avgScore": 6.795946517972767,
                "count": 10
            },
            "Excretory System": {
                "totalQuestions": 10,
                "avgTime": 289.99703826676523,
                "avgScore": 6.023268303140359,
                "count": 9
            },
            "Plants": {
                "totalQuestions": 16,
                "avgTime": 323.0463690933241,
                "avgScore": 10.00407069868224,
                "count": 9
            },
            "Skeletal System": {
                "totalQuestions": 9,
                "avgTime": 201.47902799451523,
                "avgScore": 6.695901306180749,
                "count": 6
            },
            "Respiratory System": {
                "totalQuestions": 6,
                "avgTime": 122.82389160452821,
                "avgScore": 4.476318002800387,
                "count": 5
            },
            "Integumentary System": {
                "totalQuestions": 5,
                "avgTime": 72.58540402169422,
                "avgScore": 4.008162721505797,
                "count": 5
            }
        }
    },
    "General Chemistry": {
        "totalQuestions": 300,
        "avgTime": 15028.149868285916,
        "avgScore": 202.02375024272348,
        "count": 10,
        "systems": {
            "Periodic Trends": {
                "totalQuestions": 25,
                "avgTime": 916.2864975997675,
                "avgScore": 17.740202466187505,
                "count": 9
            },
            "Liquids and Solids": {
                "totalQuestions": 25,
                "avgTime": 951.6561776955323,
                "avgScore": 17.119543094432014,
                "count": 9
            },
            "Chemical Kinetics": {
                "totalQuestions": 21,
                "avgTime": 1099.5744336964242,
                "avgScore": 13.455266433389085,
                "count": 10
            },
            "Chemical Equilibria": {
                "totalQuestions": 18,
                "avgTime": 887.9718955858187,
                "avgScore": 11.325147816181273,
                "count": 10
            },
            "Thermodynamics and Thermochemistry": {
                "totalQuestions": 29,
                "avgTime": 1571.6120205370748,
                "avgScore": 19.215458665453166,
                "count": 10
            },
            "Stoichiometry": {
                "totalQuestions": 19,
                "avgTime": 1848.2222229234337,
                "avgScore": 13.193568522709525,
                "count": 9
            },
            "Gases": {
                "totalQuestions": 20,
                "avgTime": 1195.324265522272,
                "avgScore": 13.971976469988427,
                "count": 10
            },
            "Chemical Solutions": {
                "totalQuestions": 23,
                "avgTime": 1472.5286987139243,
                "avgScore": 13.871930045497251,
                "count": 10
            },
            "Molecular Structure and Geometry": {
                "totalQuestions": 16,
                "avgTime": 730.7632787240523,
                "avgScore": 11.173983385036955,
                "count": 10
            },
            "Electrochemistry and Oxidation Reduction Reactions": {
                "totalQuestions": 22,
                "avgTime": 1078.2105822926928,
                "avgScore": 13.353595379738568,
                "count": 10
            },
            "Atomic and Electronic Structure": {
                "totalQuestions": 21,
                "avgTime": 864.359782409264,
                "avgScore": 16.053810194557748,
                "count": 9
            },
            "Acid Base Equilibria and Titrations": {
                "totalQuestions": 26,
                "avgTime": 1168.6075353529027,
                "avgScore": 16.54835128764587,
                "count": 10
            },
            "Nuclear Reactions": {
                "totalQuestions": 14,
                "avgTime": 660.1813702242292,
                "avgScore": 9.801649306915605,
                "count": 10
            },
            "Laboratory Techniques": {
                "totalQuestions": 21,
                "avgTime": 582.8511070085274,
                "avgScore": 15.199267174990494,
                "count": 10
            }
        }
    },
    "Organic Chemistry": {
        "totalQuestions": 300,
        "avgTime": 12402.98255879579,
        "avgScore": 190.85825968296422,
        "count": 10,
        "systems": {
            "Acids and Bases": {
                "totalQuestions": 32,
                "avgTime": 1199.704529309941,
                "avgScore": 19.61110031352611,
                "count": 10
            },
            "Nomenclature": {
                "totalQuestions": 18,
                "avgTime": 888.3969307489058,
                "avgScore": 13.410014628213585,
                "count": 10
            },
            "Stereochemistry": {
                "totalQuestions": 23,
                "avgTime": 1134.933322849668,
                "avgScore": 14.546967145192486,
                "count": 9
            },
            "IM Forces and Lab Techniques": {
                "totalQuestions": 22,
                "avgTime": 634.1175828566264,
                "avgScore": 14.743052720617992,
                "count": 10
            },
            "Carboxylic Acids and Acid Derivatives": {
                "totalQuestions": 17,
                "avgTime": 706.6371282856429,
                "avgScore": 10.918862946701566,
                "count": 9
            },
            "Spectroscopy": {
                "totalQuestions": 20,
                "avgTime": 835.6987050827688,
                "avgScore": 12.547285142838595,
                "count": 10
            },
            "Aromatic Compounds": {
                "totalQuestions": 28,
                "avgTime": 1282.775092056818,
                "avgScore": 16.72724696621749,
                "count": 10
            },
            "Aldehydes and Ketones": {
                "totalQuestions": 18,
                "avgTime": 704.7137769576018,
                "avgScore": 10.95617863858597,
                "count": 10
            },
            "Alkenes and Alkynes": {
                "totalQuestions": 34,
                "avgTime": 1444.1779237872513,
                "avgScore": 22.272180190254588,
                "count": 10
            },
            "Free Radical Halogenation and Diels Alder": {
                "totalQuestions": 10,
                "avgTime": 363.392790225705,
                "avgScore": 6.5713736182498295,
                "count": 7
            },
            "Alpha Substitution Reactions of Carbonyls": {
                "totalQuestions": 8,
                "avgTime": 395.17839760324597,
                "avgScore": 4.463463721019774,
                "count": 7
            },
            "Substitution and Elimination": {
                "totalQuestions": 30,
                "avgTime": 1144.6763532987172,
                "avgScore": 19.094298949298903,
                "count": 10
            },
            "Bonding and Molecular Geometry": {
                "totalQuestions": 23,
                "avgTime": 986.22372270737,
                "avgScore": 14.188049167598438,
                "count": 10
            },
            "Alcohols Ethers Epoxides": {
                "totalQuestions": 17,
                "avgTime": 682.3563030255266,
                "avgScore": 10.808185534648892,
                "count": 9
            }
        }
    },
    "Perceptual Ability": {
        "totalQuestions": 900,
        "avgTime": 33963.5290210539,
        "avgScore": 590.0583833349306,
        "count": 10,
        "systems": {
            "Keyhole": {
                "totalQuestions": 150,
                "avgTime": 6995.096272106979,
                "avgScore": 88.48696930042924,
                "count": 10
            },
            "TFE": {
                "totalQuestions": 150,
                "avgTime": 5819.089386425476,
                "avgScore": 87.16878811904418,
                "count": 10
            },
            "Angle Ranking": {
                "totalQuestions": 150,
                "avgTime": 4513.449121557795,
                "avgScore": 92.29269476776558,
                "count": 10
            },
            "Hole Punching": {
                "totalQuestions": 150,
                "avgTime": 6663.530075985708,
                "avgScore": 109.33197915033931,
                "count": 10
            },
            "Cube Counting": {
                "totalQuestions": 150,
                "avgTime": 4480.9512442693485,
                "avgScore": 115.23249858308614,
                "count": 10
            },
            "Pattern Folding": {
                "totalQuestions": 150,
                "avgTime": 5491.4129207085925,
                "avgScore": 97.545453414266,
                "count": 10
            }
        }
    },
    "Reading Comprehension": {
        "totalQuestions": 500,
        "avgTime": 31137.014841591474,
        "avgScore": 362.96362978112506,
        "count": 10,
        "systems": {
            "Passage 1": {
                "totalQuestions": 168,
                "avgTime": 11407.249654139128,
                "avgScore": 124.4003587481022,
                "count": 10
            },
            "Passage 2": {
                "totalQuestions": 169,
                "avgTime": 10988.580687466092,
                "avgScore": 125.53974580961545,
                "count": 10
            },
            "Passage 3": {
                "totalQuestions": 163,
                "avgTime": 8741.18449998625,
                "avgScore": 113.0235252234074,
                "count": 10
            }
        }
    },
    "Quantitative Reasoning": {
        "totalQuestions": 400,
        "avgTime": 22900.865579048812,
        "avgScore": 264.7000744468407,
        "count": 10,
        "systems": {
            "Algebra - Quadratic Equations and Graphical Analysis": {
                "totalQuestions": 32,
                "avgTime": 1442.108126496206,
                "avgScore": 20.739296526039738,
                "count": 10
            },
            "Statistics, Data Analysis, & Interpretation": {
                "totalQuestions": 44,
                "avgTime": 2278.986583896945,
                "avgScore": 32.07133822252213,
                "count": 10
            },
            "Word Problems": {
                "totalQuestions": 94,
                "avgTime": 6722.576077866911,
                "avgScore": 60.300240996474955,
                "count": 10
            },
            "Quantitative Comparison": {
                "totalQuestions": 56,
                "avgTime": 2486.217221676479,
                "avgScore": 38.31929012958852,
                "count": 10
            },
            "Algebra - Equations and Inequalities": {
                "totalQuestions": 30,
                "avgTime": 1834.5001362462483,
                "avgScore": 20.957328247045997,
                "count": 10
            },
            "Algebra - Fundamentals ": {
                "totalQuestions": 51,
                "avgTime": 3196.9474680774447,
                "avgScore": 36.260886371942064,
                "count": 10
            },
            "Probability": {
                "totalQuestions": 55,
                "avgTime": 3342.949504145883,
                "avgScore": 36.56853809212631,
                "count": 10
            },
            "Data Sufficiency": {
                "totalQuestions": 33,
                "avgTime": 1385.7309415494838,
                "avgScore": 16.72875762215233,
                "count": 10
            },
            "Geometry": {
                "totalQuestions": 2,
                "avgTime": 94.60985369490261,
                "avgScore": 0.5946974668591679,
                "count": 2
            },
            "Algebra": {
                "totalQuestions": 2,
                "avgTime": 97.81673455859863,
                "avgScore": 1.3437821185130452,
                "count": 2
            },
            "Applied Mathematics": {
                "totalQuestions": 1,
                "avgTime": 18.422930839713867,
                "avgScore": 0.8159186535764376,
                "count": 1
            }
        }
    }
};